import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import api from '../utils/api';
import './styles/SppPaymentPage.css'; // Adjust the path as necessary

import { useNavigate } from 'react-router-dom';

const StudentBucketDetailPage = ({ isSidebarCollapsed }) => {
    const { bucketId } = useParams();
    const [bucket, setBucket] = useState(null);
    const [levelList, setLevelList] = useState([]);
    const navigate = useNavigate();
    const [selectedLevel, setSelectedLevel] = useState('')
    const [registration, setRegistration] = useState('')
    const [errors, setErrors] = useState({});
    const [isSubmitting, setIsSubmitting] = useState(false); 

    useEffect(() => {
        const fetchStudentDetails = async () => {
            try {
                const response = await api.get(`/student/bucket/${bucketId}`);
                const bucketData = response.data.data || null;
                setBucket(bucketData);
                if (bucketData && bucketData.Student.StudentLevels.length > 0) {
                    setSelectedLevel(bucketData.Student.StudentLevels[0].level_id); // Set level_id yang sesuai
                }
                if (bucketData.Type.type_name !== 'PURCHASE') {
                    setRegistration(true);
                }
            } catch (error) {
                console.error("Failed to fetch student details", error);
            }
        };

        fetchStudentDetails();
        
        
        
        
    }, [bucketId]);

    useEffect(() => {
        const fetchLevelList = async () => {
            if (registration) {
                try {
                    const response = await api.get(`/utils/getLevelList?program_id=${bucket.Student.StudentLevels[0].mainProgram.program_id}`);
                    const levels = response.data.data.levelList.map(level => ({
                        id: level.level_id,
                        name: level.level_name,
                    }));
                    setLevelList(levels);
                } catch (error) {
                    console.error("Failed to fetch level list", error);
                }
            }
        };
    
        fetchLevelList();
    }, [bucket]);

    

   
    const validateForm = (formData) => {
        const errors = {};
    
        // Cek jika field kosong
        if (!formData.level_id) errors.level_id = 'Level is required';
        return errors;
    };

    const handleSubmit = (e) => {
        e.preventDefault();

        let requestBody = {};

        if (isSubmitting) return;
    
        if (registration) {
            const formData = {
                level_id: e.target.level_id.value
            };
               
            const validationErrors = validateForm(formData);

            if (Object.keys(validationErrors).length > 0) {
                // Jika ada error, set state errors untuk menampilkan pesan error
                setErrors(validationErrors);
                console.log('Validation Errors:', validationErrors);
                return;
            } else {
                requestBody = {
                    data: {
                        bucketData: {
                            student_id: bucket.Student.student_id,
                            bucket_id: bucketId,   
                            level_id: formData.level_id,   
                        }
                    }
                };
            }
        } else {
            requestBody = {
                data: {
                    bucketData: {
                        student_id: bucket.Student.student_id,
                        bucket_id: bucketId  
                    }
                }
            };
        }

        const confirmation = window.confirm('Are you sure you want to proceed with this action?');
        if (!confirmation) {
            return;
        }
        
        setIsSubmitting(true);

        api.post('student/bucket/update', requestBody)
        .then(response => {
            console.log('Bucket submitted successfully:', response.data);
            
            const Message = response.data.message;
            navigate('/success', { state: { message: Message } });
            
        })
        .catch(error => {
            console.error('Error adding student:', error);
            const errorMessage = error.response.data.message
            navigate('/error', { state: { message: errorMessage } });
        });
        
    };

    if (!bucket) return <p>Loading bucket details...</p>;

    return (
        <div className={`page-content ${isSidebarCollapsed ? 'collapsed' : ''} spp-payment`}>
            <div className="page-title">Book Handover Detail</div>
            <div className="form-container">
                <form onSubmit={handleSubmit}>
                    <div className="section">
                        <h3 className="section-header">Student Data</h3>
                        <table>
                            <tbody>
                                <tr>
                                    <td>Name</td>
                                    <td>:</td>
                                    <td>{bucket.Student.student_name}</td>
                                </tr>
                                <tr>
                                    <td>NIK</td>
                                    <td>:</td>
                                    <td>{bucket.Student.student_code}</td>
                                </tr>
                                <tr>
                                    <td>Program</td>
                                    <td>:</td>
                                    <td>{bucket.Student.StudentLevels[0].mainProgram.program_name}</td>
                                </tr>
                                <tr>
                                    <td>Level</td>
                                    <td>:</td>
                                    {
                                        bucket.Type.type_name === 'PURCHASE' ? 
                                        <td>{bucket.Student.StudentLevels[0].Level.level_name}</td> : 
                                        <td>
                                            <select name="level_id" value={selectedLevel} onChange={(e) => setSelectedLevel(e.target.value)}>
                                                <option value="">Select Level</option>
                                                {levelList.map(level => (
                                                    <option key={level.id} value={level.id}>{level.name}</option>
                                                ))}
                                            </select>
                                            {errors.level_id && <div className="error-message">{errors.level_id }</div>}
                                        </td>
                                    }
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    {bucket.BucketDetails.length > 0 && (
                        <div className="section">
                            <h3>Items to Collect</h3>
                            <table>
                                <tbody>
                                    {bucket.BucketDetails.map(bucketDetail => (
                                        <tr key={bucketDetail.bucket_detail_id}>
                                            <td>{bucketDetail.Inventory.item_name}</td>
                                        </tr>
                                    ))}
                                        
                                    
                                </tbody>
                            </table>
                        </div>
                    )}
                    <div className="search-container">
                        <button type="submit">Submit</button>  
                        <button onClick={() => navigate(`/studentbucket`)}>Back</button>
                    </div>
                </form>
                
                
            </div>
        </div>
    );
};

export default StudentBucketDetailPage;
